/** @format */

import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconChevronDownOutline,
  homefieldIconChevronUpOutline,
} from '@dsg-tech/homefield-angular-icons';

import { HomefieldAccordionComponent } from './accordion.component';
import { NgModule } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@NgModule({
  imports: [NgTemplateOutlet, HomefieldIconLibraryModule],
  declarations: [HomefieldAccordionComponent],
  exports: [HomefieldAccordionComponent],
})
export class HomefieldAccordionModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([
      homefieldIconChevronUpOutline,
      homefieldIconChevronDownOutline,
    ]);
  }
}
